import React from 'react';
import mixpanel from 'mixpanel-browser';

import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'semantic-ui-css/semantic.min.css'

import Home from './home/home'

import Tour from './tour/tourCore.tsx'
import TournamentIndex from './tour/tournament/TournamentIndex'

import MyTournamentIndex from 'tour/myTours/MyTournamentsIndex'

import Melee from './draft/draftIndex'

import { MeleeContextProvider } from './draft/context/MeleeContextProvider'

import Compendium from 'compendium/Compendium';

import Tutorial from 'tutorial/tutorial';

import PlayerRanks from 'playerprofile/playerRanks';
import PlayerProfile from 'playerprofile/playerprofile';

import HeroRanks from 'playerprofile/heroRanks';

import {
  Route,
  Routes
} from "react-router-dom";

// <Route path="/draft" element={<Melee/>} />
// <MeleeContextProvider className="App"> 


function App() {
  mixpanel.init('7fca04e0623a9d36dd3283077253f975', { debug: false });

  return (
    <div className="App">
      <MeleeContextProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/draft" element={<Melee />} />

          <Route path="/create" element={<Tour />} />
          <Route path="/tournaments" element={<MyTournamentIndex />} />

          <Route path="/tournament/:id" element={<TournamentIndex />} />

          <Route path="/compendium" element={<Compendium />} />

          <Route path="tutorial" element={<Tutorial />} />

          <Route path="/players" element={<PlayerRanks />} />
          <Route path="/players/:playerName" element={<PlayerProfile />} />
          <Route path="/player/:playerName" element={<PlayerProfile />} />

          <Route path="/heroes" element={<HeroRanks />} />

        </Routes>
      </MeleeContextProvider>
    </div>
  );
}

export default App;

